export enum CartQuantityActionEnum {
    Update = 'update',
    Remove = 'remove',
}